// extracted by mini-css-extract-plugin
export var one = "styles-module--one--pj3ik";
export var grid = "styles-module--grid--BSLit";